/**
 * O grifo de marca-texto que a direção aprovada
 * (`docs/design/bio-links/direcao-3-estudio.html`) usa duas vezes: no verbo
 * "organiza" do `BioProfileHeader` e em "todos" do `BioCollabBlock`. Mesmo
 * tratamento visual nos dois lugares — por isso uma constante só, e não uma
 * string repetida em cada componente.
 *
 * Decorativo: a ordem das palavras já diz o que a frase quer dizer, então um
 * leitor de tela não precisa anunciar o destaque.
 */
export const HIGHLIGHT_MARK_CLASS =
  "-rotate-[1.1deg] inline-block rounded-tl-[3px] rounded-tr-[9px] rounded-br-[6px] rounded-bl-[9px] bg-tami-green px-[7px] pb-0.5 pt-px font-bold text-tami-dark [box-decoration-break:clone] [-webkit-box-decoration-break:clone]";
